module.exports = __webpack_public_path__ + "static/media/siberian-husky.68dbc0e2.svg";